import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";

import Endpoints from "./Endpoints/Endpoints";
import ENDPOINT from "../../../assets/vw/svg/endpoint.svg";
import ENDPOINT_AZUL from "../../../assets/vw/svg/endpoint.svg";

const PESTAÑA_ENDPOINTS = {
  label: "Probar Endpoint DMS",
  value: "endpoints",
  icon: ENDPOINT,
  iconActive: ENDPOINT_AZUL,
};

const APLICACIONES = {
  CDS: {
    urlApi: process.env.REACT_APP_URL_DTO_CT_CDS,
    pestañas: [PESTAÑA_ENDPOINTS],
  },
  CTA: {
    urlApi: process.env.REACT_APP_URL_DTO_CT_CTA,
    pestañas: [PESTAÑA_ENDPOINTS],
  },
};

function SoporteCentroTecnico(props) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const app = params.get("app") === "consulta-avaluo" ? "CTA" : "CDS";

  const configuracion = APLICACIONES[app];

  const [pestana, setPestana] = useState("endpoints");

  const [modal, setModal] = useState({
    active: false,
    message: "",
    success: false,
  });

  return (
    <>
      <Menu />

      <Modal
        modalInfo={modal}
        setMostrarModal={setModal}
      />

      <div className="navegacion">
        {/* Pestañas disponibles para esta aplicación */}
        <div className="posicionMenu mt-3">
          <ul className="d-flex flex-row px-0 my-0">
            {configuracion.pestañas.map((item) => (
              <li
                key={item.value}
                className="opcion-ruta normal_width"
                onClick={() => setPestana(item.value)}
              >
                <div
                  className={`nav-link nav-link-title ps-0 mr-3 ${
                    pestana === item.value ? "active border_menu" : ""
                  }`}
                >
                  <img
                    src={pestana === item.value ? item.iconActive : item.icon}
                    alt={item.label}
                    className="icono-menu me-3"
                  />
                  {item.label}
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Contenido de la pestaña activa */}
        <div className="row border_vw pt-4 ms-0 mx-0">
          <div className="col-12 pt-4 contenedor-table">
            {pestana === "endpoints" && (
              <Endpoints
                key={app}
                app={app}
                urlApi={configuracion.urlApi}
                servicio={props.servicio}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SoporteCentroTecnico;